import { render } from "./CustomerBagPitForm.vue?vue&type=template&id=5777b21e"
import script from "./CustomerBagPitForm.vue?vue&type=script&lang=js"
export * from "./CustomerBagPitForm.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__